import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, delay: number = 0): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;
    if (delay === 0) {
      setDebouncedValue(value);
    } else {
      timeout = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    };
  }, [value, delay]);

  return debouncedValue;
}
